import { EmpresaContext } from "../context/empresa-context";
import { AuthContext } from "../context/auth-context";
import axiosGenerico from "../utils/axiosGenerico";
import { useCargando } from "../context/cargando-context";
import {
  Box,
  Button,
  Card,
  FormControl,
  Grid2,
  TextField,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";

export default function LoginPage() {
  const { enqueueSnackbar } = useSnackbar();
  const { cargarEmpresa, empresa } = useContext(EmpresaContext);
  const { login } = useContext(AuthContext);
  const { empezarCarga, terminarCarga } = useCargando();

  const [loginData, setLoginData] = useState({
    usuario: "",
    password: "",
  });

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      empezarCarga();
      const form = {
        codigo: loginData.usuario,
        clave: loginData.password,
      };
      await axiosGenerico.post("/auth/login", form).then((res) => {
        console.log(res.data);
        login(res.data.user, res.data.accessToken);
        // navigate("/");
      });
    } catch (error) {
      console.error("Error:", error);
      enqueueSnackbar("Usuario o contraseña incorrectos", {
        variant: "error",
      });
    } finally {
      terminarCarga();
    }
  };

  useEffect(() => {
    cargarEmpresa();
  }, []);

  return (
    <Grid2
      padding={2}
      container
      spacing={1}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
        <Box
          component="form"
          onSubmit={handleSubmit}
          noValidate
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            gap: 2,
            p: 2,
          }}
        >
          <Card sx={{ borderRadius: 2, height: "90vh" }} elevation={3}>
            <Grid2
              container
              spacing={1}
              justifyContent={"center"}
              alignItems={"center"}
              sx={{ position: "relative", p: 2 }}
            >
              <Grid2>
                <Typography
                  component="h1"
                  variant="h4"
                  sx={{
                    width: "100%",
                    fontSize: "clamp(2rem, 10vw, 2.15rem)",
                    p: 2,
                    textAlign: "center",
                    fontWeight: "bold",
                    fontFamily: "Montserrat",
                  }}
                >
                  {empresa?.nombre}
                </Typography>
              </Grid2>
              <Grid2
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                  mt: 1,
                }}
              >
                <img
                  src={empresa?.logo_empresa} // Usa la imagen importada
                  alt={empresa?.nombre}
                  style={{
                    maxWidth: "60%",
                    height: "auto",
                  }}
                />
              </Grid2>
              <Grid2>
                <Typography
                  component="h1"
                  variant="h4"
                  sx={{
                    width: "100%",
                    fontSize: "clamp(2rem, 10vw, 2.15rem)",
                    pb: 2,
                    textAlign: "center",
                  }}
                >
                  Iniciar Sesión
                </Typography>
              </Grid2>
              <FormControl>
                <TextField
                  // error={emailError}
                  // helperText={emailErrorMessage}
                  size="small"
                  placeholder="Ingrese su usuario"
                  autoFocus
                  required
                  fullWidth
                  variant="outlined"
                  // color={emailError ? "error" : "primary"}
                  sx={{ ariaLabel: "email" }}
                  value={loginData.usuario}
                  onChange={(e) =>
                    setLoginData({ ...loginData, usuario: e.target.value })
                  }
                />
              </FormControl>
              <FormControl>
                <TextField
                  // error={passwordError}
                  // helperText={passwordErrorMessage}
                  size="small"
                  name="password"
                  placeholder="••••••"
                  type="password"
                  autoComplete="current-password"
                  required
                  fullWidth
                  variant="outlined"
                  // color={passwordError ? "error" : "primary"}
                  value={loginData.password}
                  onChange={(e) =>
                    setLoginData({ ...loginData, password: e.target.value })
                  }
                />
              </FormControl>
              <Button fullWidth variant="contained" type="submit">
                Ingresar
              </Button>
            </Grid2>

            <Grid2
              container
              spacing={1}
              justifyContent={"center"}
              alignItems={"center"}
              bgcolor={"#f0f0f0"}
              sx={{ position: "absolute", bottom: 0 }}
            >
              <Typography
                component="label"
                variant="body2"
                sx={{
                  width: "100%",
                  fontSize: "clamp(0.5rem, 2.5vw, 0.6rem)",
                  p: 1,
                  textAlign: "center",
                }}
              >
                {`En Ecuador la emisión de comprobantes de venta, documentos complementarios y comprobantes de retención se reglamentan como mensajes de datos en la resolución No. NAC-DGERCGC12-00105, publicada en el Registro Oficial 666 de 21 de marzo de 2012.`}
              </Typography>
            </Grid2>
          </Card>
        </Box>
      </Grid2>
    </Grid2>
  );
}
